// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Slider_Slider__1ZFiO","SliderLabel":"Slider_SliderLabel__3A6WD"};